/**
 * TODO - preamble
 *
 * Empty objects, useful for initializing
 */

import { deepClone } from '../../lib/utils/objects';

import {
    SeniorPersonalInfoViewModel,
    StudentPersonalInfoViewModel,
    TeacherPersonalInfoViewModel,
    ActiveMilitaryPersonalInfoViewModel,
    DocUploadViewModel,
    FieldValidationErrors,
    InactiveMilitaryPersonalInfoViewModel,
    FirstResponderPersonalInfoViewModel,
    MedicalProfessionalPersonalInfoViewModel,
    EmploymentPersonalInfoViewModel,
    ProgramTheme,
    SSOViewModel,
    WithCoreFields,
} from './types';
import { getCustomValidatorFields } from '../validators/customValidators';

const coreFieldsEmpty: WithCoreFields = {
    firstName: '',
    lastName: '',
    email: '',
};

const withLocaleAndCountryEmpty = {
    countryChoice: undefined,
    localeChoice: {
        value: undefined,
        label: undefined,
    },
};

// TODO use Object.freeze here
export const stuPInfoReqEmpty: StudentPersonalInfoViewModel = {
    ...coreFieldsEmpty,
    ...withLocaleAndCountryEmpty,
    birthDate: '',
    organization: {
        id: 0,
        name: '',
    },
    metadata: { marketConsentValue: false },
};

// TODO use Object.freeze here
export const seniorPInfoReqEmpty: SeniorPersonalInfoViewModel = {
    ...coreFieldsEmpty,
    ...withLocaleAndCountryEmpty,
    birthDate: '',
    postalCode: '',
    metadata: { marketConsentValue: false },
};

// TODO use Object.freeze here
export const teaPInfoReqEmpty: TeacherPersonalInfoViewModel = {
    ...coreFieldsEmpty,
    ...withLocaleAndCountryEmpty,
    organization: {
        id: 0,
        name: '',
    },
    metadata: { marketConsentValue: false },
};

export const activeMilitaryPInfoReqEmpty: ActiveMilitaryPersonalInfoViewModel = {
    ...coreFieldsEmpty,
    ...withLocaleAndCountryEmpty,
    birthDate: '',
    organization: {
        id: 0,
        name: '',
    },
    status: undefined,
    metadata: { marketConsentValue: false },
};

export const inactiveMilitaryPInfoReqEmpty: InactiveMilitaryPersonalInfoViewModel = {
    ...coreFieldsEmpty,
    ...withLocaleAndCountryEmpty,
    birthDate: '',
    dischargeDate: '',
    organization: {
        id: 0,
        name: '',
    },
    status: undefined,
    metadata: { marketConsentValue: false },
};

export const firstResponderPInfoReqEmpty: FirstResponderPersonalInfoViewModel = {
    ...coreFieldsEmpty,
    ...withLocaleAndCountryEmpty,
    birthDate: '',
    organization: {
        id: 0,
        name: '',
    },
    status: undefined,
    metadata: { marketConsentValue: false },
};

export const medicalProfessionalPInfoReqEmpty: MedicalProfessionalPersonalInfoViewModel = {
    ...coreFieldsEmpty,
    ...withLocaleAndCountryEmpty,
    birthDate: '',
    postalCode: '',
    organization: {
        id: 0,
        name: '',
    },
    status: undefined,
    metadata: { marketConsentValue: false },
};


export const employmentPInfoReqEmpty: EmploymentPersonalInfoViewModel = {
    ...coreFieldsEmpty,
    ...withLocaleAndCountryEmpty,
    postalCode: '',
    organization: {
        id: 0,
        name: '',
    },
    address1: '',
    city: '',
    state: '',
    metadata: { marketConsentValue: false },
};

// TODO use Object.freeze here
export const docUploadEmpty: DocUploadViewModel = {
    ...withLocaleAndCountryEmpty,
    file1: undefined,
    file2: undefined,
    file3: undefined,
};

export const ssoEmpty: SSOViewModel = {
    ...withLocaleAndCountryEmpty,
    isSSOActive: false,
};

const initialErrorStructure = Object.freeze({
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    phoneNumber: undefined,
    birthDate: undefined,
    organization: undefined,
    postalCode: undefined,
    address1: undefined,
    city: undefined,
    state: undefined,
    dischargeDate: undefined,
    docUpload: undefined,
    status: undefined,
    marketConsentValue: undefined,
});

export const getFieldValidationErrorsEmpty = (): FieldValidationErrors => deepClone(initialErrorStructure);

export const getExtendedFieldValidationErrorsEmpty = () => {
    const customValidatorFieldsEmpty = {};
    const customValidatorFields = getCustomValidatorFields();
    if (customValidatorFields) {
        for (const field of customValidatorFields) {
            customValidatorFieldsEmpty[field] = undefined;
        }
    }
    return customValidatorFieldsEmpty;
};

export const GetEmptyTheme = (): ProgramTheme => ({
    intl: {
        locale: 'en-US',
        // @ts-ignore
        messages: {},
    },
    customCss: '',
});
